import { ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { commonAppConfig } from '@ui/layout/common-app/common-app.config';
import { AppRoutingModule } from './app-routing.module';


export const appConfig: ApplicationConfig = mergeApplicationConfig(commonAppConfig, {
    providers: [importProvidersFrom(AppRoutingModule)],
});
